import request, { METHODS } from "src/utils/api-base";

const brandApis = {
  createBrand: (payload: any) => {
    return request({
      route: "/app/brands",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },

  getBrandList: (params: {
    page?: number;
    limit: number;
    status?: "active" | "inactive";
    search?: string;
  }) => {
    return request({
      route: "/app/brands",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  editBrand: (payload: any) => {
    return request({
      route: `/app/brands/${payload._id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },

  deleteBrand: (_id: string) => {
    return request({
      route: `/app/brands/${_id}`,
      method: METHODS.DELETE,
      auth: true,
    });
  },

  // Bulk-create brands from parsed spreadsheet rows
  bulkImport: (rows: Array<Record<string, any>>) => {
    return request({
      route: "/app/brands/bulk-import",
      method: METHODS.POST,
      payload: { rows },
      auth: true,
    });
  },
};

export default brandApis;
